import React from "react";

type OnBeforeNavigateContextValue = {
  handlers: Set<() => Promise<void>>;
};

const OnBeforeNavigateContext =
  React.createContext<OnBeforeNavigateContextValue>({
    handlers: new Set(),
  });

export const useOnBeforeNavigate = (fn: () => Promise<void>): void => {
  const ctx = React.useContext(OnBeforeNavigateContext);

  React.useEffect(() => {
    ctx.handlers.add(fn);

    return () => {
      ctx.handlers.delete(fn);
    };
  }, [fn, ctx]);
};

export function OnBeforeNavigateProvider({
  children,
  handlers,
}: {
  children: React.ReactNode;
  handlers: Set<() => Promise<void>>;
}): React.ReactElement {
  const ctx = React.useRef<OnBeforeNavigateContextValue>({
    handlers,
  });

  return (
    <OnBeforeNavigateContext.Provider value={ctx.current}>
      {children}
    </OnBeforeNavigateContext.Provider>
  );
}
